module.exports = __webpack_public_path__ + "media/application/images/2023/06_still-1450x816-3018ef10209940ba746d3abf48bcd652.png";